<mat-form-field class="example-full-width">
  <textarea matInput placeholder="{{ placeholder }} " [formControl]="inputControl" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="10"></textarea>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="inputControl.hasError('required')">{{ requiredErrorMessage }}</mat-error>
</mat-form-field>
